import React from "react";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSubtopicCYK = () => (
  <TOCModuleSubtopic
    title="CYK Algorithm"
    videos={[
      "https://www.youtube.com/embed/xRMn6HK84io",
    ]}
    takeaways={[
      { text: "Remember that the CYK algorithm is also called the Membership Algorithm." },
      { text: "If you understand the two given example questions, you can solve most CYK algorithm problems." },
    ]}
    questions={[
      {
        text: "Determine whether the string w='He eats a fish with a fork' is in the language generated by the given grammar G using the CYK Algorithm.",
        image: "/image1.png", // Replace with actual image URL
      },
      {
        text: "Consider the following context-free grammar (where A is the start symbol). Apply the CYK algorithm for the input string abbaa. Find the nonterminal set where X is marked in the table.",
        image: "/image2.png", // Replace with actual image URL
      },
    ]}
    exampleVideos={[]} // Add example question videos if needed
  />
);

export { ModuleSubtopicCYK };
